// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"3e518d39","407":"0837b0fb","782":"3058e018"}[chunkId] + ".chunk.css";
};